<div class="title" mat-dialog-title>Add UserId & API Secret</div>
<div class="dialog-body">
    <div class="body-content">
        <div class="form-text">You will need to contact your Adobe Account Manager to obtain the details below</div>
        <form [formGroup]="connectionForm">
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>Adobe UserId</mat-label>
                <input matInput placeholder="Enter Adobe UserId" formControlName="userId" data-cy="adobe-user-id-input">
                <mat-error
                    *ngIf="connectionForm.get('userId').errors && (connectionForm.get('userId').touched || connectionForm.get('userId').dirty)">
                    Invalid UserId</mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="form-field">
                <mat-label>Adobe Api Secret</mat-label>
                <input type="password" matInput placeholder="Enter Adobe Api Secret" formControlName="apiSecret" data-cy="adobe-api-secret-input">
                <mat-error
                    *ngIf="connectionForm.get('apiSecret').errors && (connectionForm.get('apiSecret').touched || connectionForm.get('apiSecret').dirty)">
                    Invalid Api Secret</mat-error>
                </mat-form-field>
        </form>
    </div>
</div>
<div class="dialog-footer">
    <div>
        <button mat-raised-button class="rubii-btn add-btn" color="primary" (click)="connect()" data-cy="adobe-dialog-connect-btn">
            Connect Data Source
        </button>
    </div>
</div>